import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { ProgressSpinner } from 'primereact/progressspinner';
import Pagination from 'react-js-pagination';

const STATUS_COLORS = {
    Pendente: { bg: '#3d5b5a', color: '#fff' },
    Processando: { bg: '#F3CE00', color: '#4D5830' },
    Processado: { bg: '#4D5A31', color: '#fff' },
    Falhado: { bg: '#dc3545', color: '#fff' },
};

const STATUS_LABELS = {
    Pendente: 'PENDENTE',
    Processando: 'ANDAMENTO',
    Processado: 'FINALIZADO',
    Falhado: 'FALHADO',
};

class AnaliseTemporalExportTable extends Component {
    constructor(props) {
        super(props);
        this.state = {
            rows: [],
            currentPage: 1,
            lastPage: 1,
            perPage: 20,
            total: 0,
            loading: true,
            requeueingId: null,
        };
    }

    componentDidMount() {
        this.loadPage(1);
        this.onExportCreated = () => this.loadPage(1);
        window.addEventListener('analise-export-created', this.onExportCreated);
    }

    componentWillUnmount() {
        window.removeEventListener('analise-export-created', this.onExportCreated);
    }

    loadPage = async (page) => {
        this.setState({ loading: true });
        try {
            const response = await axios.get(route('analise_temporal.exports_json'), { params: { page } });
            const { data, current_page, last_page, per_page, total } = response.data;
            this.setState({ rows: data, currentPage: current_page, lastPage: last_page, perPage: per_page, total, loading: false });
        } catch (e) {
            console.error('Erro ao carregar exports:', e);
            this.setState({ loading: false });
        }
    };

    requeue = async (row) => {
        if (!confirm('Colocar para reprocessamento?')) return;
        this.setState({ requeueingId: row.id });
        try {
            await axios.post(row.enqueue_url, {}, {
                headers: { 'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]')?.getAttribute('content') },
            });
            await this.loadPage(this.state.currentPage);
        } catch (e) {
            console.error('Erro ao reenfileirar:', e);
        } finally {
            this.setState({ requeueingId: null });
        }
    };

    renderStatusBadge(row) {
        const style = STATUS_COLORS[row.status] || STATUS_COLORS.Pendente;
        const label = STATUS_LABELS[row.status] || row.status;
        return (
            <span style={{
                display: 'inline-block',
                padding: '3px 10px',
                borderRadius: '3px',
                fontSize: '17x',
                fontWeight: 'bold',
                letterSpacing: '0.03em',
                backgroundColor: style.bg,
                color: style.color,
                fontFamily: "'Archivo Expanded', sans-serif",
            }}>
                {label}
            </span>
        );
    }

    handlePageChange = (pageNumber) => {
        this.loadPage(pageNumber).then(r => window.scrollTo({ top: 0, behavior: 'smooth' }));
    };

    render() {
        const { rows, loading, currentPage, perPage, total } = this.state;
        const { canVerSolicitante } = this.props;

        const thStyle = {
            padding: '10px 12px',
            fontFamily: "'Archivo Expanded', sans-serif",
            fontSize: '23px',
            fontWeight: 'bold',
            fontStyle: 'normal',
            color: '#5B595B',
            border: 'none',
            textAlign: 'left',
            whiteSpace: 'nowrap',
        };

        const tdStyle = {
            padding: '10px 12px',
            fontSize: '19px',
            color: '#5B595B',
            border: '1px solid #dee2e6',
            verticalAlign: 'middle',
            fontFamily: "'Archivo Expanded', sans-serif",
            fontWeight: 400,
        };

        return (
            <div>
                <h5>Meus relatórios</h5>

                {loading && rows.length === 0 ? (
                    <div className="d-flex justify-content-center py-4">
                        <ProgressSpinner style={{ width: '40px', height: '40px' }} />
                    </div>
                ) : (
                    <>
                        <div style={{ overflowX: 'auto' }}>
                            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                                <thead>
                                    <tr>
                                        <th style={{ ...thStyle, width: '50px' }}>#</th>
                                        <th style={{ ...thStyle, width: '120px' }}>Status</th>
                                        <th style={thStyle}>Período</th>
                                        <th style={thStyle}>Formato</th>
                                        <th style={thStyle}>Agrupamento</th>
                                        <th style={thStyle}>Todas as cidades</th>
                                        <th style={thStyle}>Solicitação</th>
                                        <th style={thStyle}>Finalização</th>
                                        {canVerSolicitante && <th style={thStyle}>Solicitante</th>}
                                        <th style={{ ...thStyle, width: '70px', textAlign: 'center' }}>Baixar</th>
                                    </tr>
                                </thead>
                                <tbody style={{fontFamily: "'Archivo Expanded', sans-serif", fontWeight: 400, color: '#5B595B'}}>
                                    {rows.length === 0 && (
                                        <tr>
                                            <td colSpan={canVerSolicitante ? 9 : 8} style={{ ...tdStyle, textAlign: 'center', color: '#999', padding: '20px' }}>
                                                Nenhum registro encontrado.
                                            </td>
                                        </tr>
                                    )}
                                    {rows.map((row, index) => (
                                        <tr key={row.id} style={{backgroundColor: index % 2 === 0 ? '#EEEFF0' : '#fff' }}>
                                            <td style={tdStyle}>{row.id}</td>
                                            <td style={tdStyle}>
                                                {this.renderStatusBadge(row)}
                                            </td>
                                            <td style={tdStyle}>{row.periodo}</td>
                                            <td style={tdStyle}>{row.formato}</td>
                                            <td style={tdStyle}>{row.agrupamento || '-'}</td>
                                            <td style={tdStyle}>{row.nacional ? 'Sim' : 'Não'}</td>
                                            <td style={tdStyle}>{row.created_at}</td>
                                            <td style={tdStyle}>{row.finished_at || ''}</td>
                                            {canVerSolicitante && (
                                                <td style={tdStyle}>{row.usuario}</td>
                                            )}
                                            <td style={{ ...tdStyle, textAlign: 'center' }}>
                                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}>
                                                    <button
                                                        onClick={() => this.requeue(row)}
                                                        title="Reprocessar"
                                                        style={{ background: 'none', border: 'none', cursor: 'pointer', padding: '2px' }}
                                                    >
                                                        <img src="/img/icons/65.png" alt="Reprocessar" style={{ width: '20px', height: '20px' }} />
                                                    </button>
                                                    {row.is_finished ? (
                                                        <a href={row.download_url} title="Download">
                                                            <img src="/img/icons/64.png" alt="Download" style={{ width: '20px', height: '20px' }} />
                                                        </a>
                                                    ) : (
                                                        <img src="/img/icons/64.png" alt="Download" style={{ width: '20px', height: '20px', opacity: 0.3 }} />
                                                    )}
                                                </div>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>

                        <div className="ate-pagination d-flex justify-content-center" style={{ marginTop: '16px' }}>
                            <Pagination
                                activePage={currentPage}
                                itemsCountPerPage={perPage}
                                totalItemsCount={total}
                                pageRangeDisplayed={5}
                                onChange={this.handlePageChange}
                                itemClass="page-item"
                                linkClass="page-link"
                                prevPageText="Anterior"
                                nextPageText="Próximo"
                                firstPageText={null}
                                lastPageText={null}
                                hideFirstLastPages={true}
                            />
                        </div>

                        <style>{`
                            .ate-pagination .pagination {
                                gap: 4px;
                            }
                            .ate-pagination .page-link {
                                font-family: 'Archivo Expanded', sans-serif;
                                font-weight: bold;
                                font-size: 16px;
                                text-transform: none !important;
                                border-radius: 0 !important;
                                border: 1px solid #999;
                                background-color: rgb(178, 178, 178);
                                color: #fff !important;
                                padding: 6px 14px;
                                letter-spacing: 0.04em;
                            }
                            .ate-pagination .page-item.active .page-link {
                                background-color: #4D5A31;
                                border-color: #4D5A31;
                                color: #fff;
                            }
                            .ate-pagination .page-link:hover {
                                background-color: rgb(140, 140, 140) !important;
                                border-color: rgb(140, 140, 140);
                                color: #fff !important;
                            }
                            .ate-pagination .page-item.active .page-link:hover {
                                background-color: #4D5A31;
                                border-color: #4D5A31;
                            }
                            .ate-pagination .pagination li:first-child .page-link,
                            .ate-pagination .pagination li:last-child .page-link {
                                background-color: rgb(178, 178, 178);
                                border-color: rgb(178, 178, 178);
                                color: #fff;
                            }
                            .ate-pagination .page-item.disabled .page-link {
                                background-color: rgb(178, 178, 178);
                                border-color: rgb(178, 178, 178);
                                color: #fff;
                                opacity: 0.6;
                            }
                            .ate-pagination .pagination li:first-child.disabled {
                                display: none;
                            }
                        `}</style>
                    </>
                )}
            </div>
        );
    }
}

const el = document.getElementById('js-analise-temporal-export-table');
if (el) {
    ReactDOM.render(
        <AnaliseTemporalExportTable
            canVerSolicitante={el.dataset.canVerSolicitante === 'true'}
        />,
        el
    );
}
